import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { getCategoryTemplates } from "src/store/reducers/categoryTemplatesSlice";
import { showModal } from "src/store/reducers/modalSlice";
import { updateServices } from "src/store/reducers/servicesSlice";
import { updateServiceTemplate } from "src/store/reducers/serviceTemplatesSlice";

import { CloseIcon, WorkingTimeSidebarInfoIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";
import { RightDrawerServicePanel } from "../Selector/CustomRightDrawerServicePanel";
import { SectionHeader } from "../SideBar/CalendarSideBar/components/CreateScheduleMenu/components/Popup/components/SectionHeader";

interface MoveModalProps {
  data: any;
  categories: any;
  services?: any;
  onClose: () => void;
}

export const MoveModal = ({
  data,
  services,
  categories,
  onClose,
}: MoveModalProps) => {
  const dispatch = useAppDispatch();

  const [chosenCat, setChosenCat] = useState<null | number>(null);
  const [chosenSubCat, setChosenSubCat] = useState<null | number>(null);

  const { studio: selectedStudio } = useAppSelector((state: any) => state.selectedStudio);

  const handleSubmit = () => {
    if (selectedStudio) {
      dispatch(
        updateServices({
          ...data,
          studioId: selectedStudio.id,
          serviceId: +data.id,
          categories: chosenSubCat ? [chosenSubCat] : [chosenCat],
          onSuccess: () => {
            dispatch(getCategoryTemplates())
            dispatch(
              showModal({
                modalType: "SUCCESS",
                successText: "Changes successfully saved",
                okButtonTitle: "Ok, I got it",
                onButtonClick: () => {
                  onClose();
                },
              })
            );
          },
          onFailure: (error: any) => {
            dispatch(
              showModal({
                modalType: "DELETE",
                title: `${error?.response?.data?.detail || error.message}`,
                okButtonTitle: "Ok, I got it",
                isButtonCancel: true,
                onButtonClick: () => {
                  onClose();
                },
              })
            );
          },
        })
      );
    } else {
      dispatch(
        updateServiceTemplate({
          ...data,
          serviceId: +data.id,
          categories: chosenSubCat ? [chosenSubCat] : [chosenCat],
          onSuccess: () => {
            dispatch(getCategoryTemplates())
            dispatch(
              showModal({
                modalType: "SUCCESS",
                successText: "Changes successfully saved",
                okButtonTitle: "Ok, I got it",
                onButtonClick: () => {
                  onClose();
                },
              })
            );
          },
          onFailure: (error: any) => {
            dispatch(
              showModal({
                modalType: "DELETE",
                title: `${error?.response?.data?.detail || error.message}`,
                okButtonTitle: "Ok, I got it",
                isButtonCancel: true,
                onButtonClick: () => {
                  onClose();
                },
              })
            );
          },
        })
      );
    }
  }

  return (
    <Box
      sx={{
        borderRadius: "16px",
        width: "524px",
        maxWidth: "524px",
        maxHeight: '677px',
      }}
    >
      <Box
        sx={{
          padding: "32px",
          borderRadius: "16px",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "#B9B9B9",
              marginBottom: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#080808",
                  marginRight: "8px",
                }}
              >
                Move Service
              </Typography>
              <WorkingTimeSidebarInfoIcon fontSize="inherit" />
            </Box>
            <Box
              onClick={onClose}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                fontSize: "24px",
                cursor: "pointer",
                "&:hover": {
                  color: "#828282",
                },
              }}
            >
              <CloseIcon fontSize="inherit" />
            </Box>
          </Box>
          <Typography
            sx={{
              color: "#9D9D9D",
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "16px",
            }}
          >
              Please choose specific category, and subcategory if needed,
              service will be moved to chosen section
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              marginBottom: '16px',
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "46px",
                minWidth: 170,
                paddingLeft: "16px",
                backgroundColor: "#F3F3F3",
                color: "#1F1F1F",
                border: "1px solid #D6D6DB",
                borderRight: "none",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Service Name
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                height: "46px",
                paddingLeft: "16px",
                color: "#1F1F1F",
                border: "1px solid #D6D6DB",
                borderLeft: "none",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
              }}
            >
              {data.title}
            </Box>
          </Box>

          <SectionHeader label="Service Category" />
          <RightDrawerServicePanel
            location='popup'
            chosenCat={chosenCat}
            chosenSubCat={chosenSubCat}
            setChosenCat={setChosenCat}
            setChosenSubCat={setChosenSubCat}
            categoriesList={categories}
            rowData={data}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
          }}
        >
          <SubmitButton
            title="Cancel"
            onClick={onClose}
            sx={{
              flex: 1,
              backgroundColor: "white",
              color: "#BF295C",
              border: "1px solid #BF295C",
              borderRadius: "6px",
              marginRight: '12px',
              "&:hover, &:active": {
                backgroundColor: "#FFF8FA",
              },
            }}
          />
          <SubmitButton
            title="Move Service"
            onClick={handleSubmit}
            sx={{
              flex: 1,
              backgroundColor: "#BF295C",
              borderRadius: "6px",
              color: "white",
              "&:hover": "none"
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
